import type { Product } from "../../types";
import { sharedE7AudienceData } from "./shared-product-data/e7Audience";

export const e7Audience: Product = {
  ...sharedE7AudienceData,
};
